import { EventAction } from './EventActions';
import { RealTimeSidebarProcessor } from './processors/RealTimeSidebarProcessor';
// Processor defined prefix
export const DESK_EVENT_PREFIX = 'Desk';
// Desk application event processor
export class DeskEventProcessor {
    static removeProcessorPrefix(path) {
        return path.replace(`${DESK_EVENT_PREFIX}:`, '');
    }
    static async process(payload) {
        const action = this.removeProcessorPrefix(payload.message.action);
        switch (action) {
            case EventAction.OpenRealTimeSideBar:
                await RealTimeSidebarProcessor.process(payload);
                break;
            default:
                throw `No processor available for action ${action}`;
        }
    }
}
